import { FlyoutMenu, IFlyoutMenuProps } from './flyout-menu';
import { CollapsibleMenu, ICollapsibleMenuProps } from './collapsible-menu';
import { ContextMenu, IContextMenuProps } from './context-menu';
import { ReplaceMenu, IReplaceMenuProps } from './replace-menu';

export const Menu = {
    FlyoutMenu,
    CollapsibleMenu,
    ContextMenu,
    ReplaceMenu
};

export type { IMenuItem, IMenuItemRenderProps } from './common/types';
export type { IFlyoutMenuProps, IContextMenuProps, ICollapsibleMenuProps, IReplaceMenuProps };
export * from './theme';
